import classNames from 'classnames';
import React from 'react';
import './../Radio/styles.css';

const Checkbox = ({
  name,
  label,
  value,
  checked,
  onChange,
  className,
  bold,
  help,
  required = false,
  checkedBold = false,
}) => {
  return (
    <div className={classNames('input-radio input-radio--checkbox', {
      'checked--bold': checkedBold,
    })}>
      <label className={classNames('input-radio__item', className)}>
        <input
          required={required}
          className={'input-radio__input'}
          type={'checkbox'}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <span className={'input-radio__label'}>
          <div className={'input-radio__label-inner'}>
            <span className={classNames('input-radio__title', {
              'input-radio__title--bold': bold,
            })}>
              {label}
              {!!help && (
                <span className={'input-radio__help'}>
                  {help}
                </span>
              )}
            </span>
          </div>
        </span>
      </label>
    </div>
  );
}

export default Checkbox;
